/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Platforms_AcInputs */

const en_pc_cmp_r_platforms_ac = /** @type {(inputs: Pc_Cmp_R_Platforms_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS, iOS, Android, web. No Linux desktop app`)
};

const zh_pc_cmp_r_platforms_ac = /** @type {(inputs: Pc_Cmp_R_Platforms_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows、macOS、iOS、Android、网页，无 Linux 桌面版`)
};

/**
* | output |
* | --- |
* | "Windows, macOS, iOS, Android, web. No Linux desktop app" |
*
* @param {Pc_Cmp_R_Platforms_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_platforms_ac = /** @type {((inputs?: Pc_Cmp_R_Platforms_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Platforms_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_platforms_ac(inputs)
	return zh_pc_cmp_r_platforms_ac(inputs)
});
export { pc_cmp_r_platforms_ac as "pc.cmp.r.platforms.ac" }